import { render, staticRenderFns } from "./PortfolioAccessDenied.vue?vue&type=template&id=c9038dca&"
import script from "./PortfolioAccessDenied.vue?vue&type=script&lang=js&"
export * from "./PortfolioAccessDenied.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports